import React, {useEffect} from 'react';
import Stack from '@mui/material/Stack';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import axios from 'axios';
import {GlobalConstants} from "../../globals/GlobalConstants";
import '../../styles/DeleteArea.css'
import {fetchAuthSession} from "aws-amplify/auth";
import Autocomplete from "@mui/material/Autocomplete";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogActions from "@mui/material/DialogActions";
import Alert from "@mui/material/Alert";
import AlertTitle from "@mui/material/AlertTitle";
import LoadingButton from "@mui/lab/LoadingButton";
import SaveIcon from "@mui/icons-material/Save";
import CircularProgress from "@mui/material/CircularProgress";
import Backdrop from "@mui/material/Backdrop";
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import {refreshToken} from "../../globals/GlobalFunctions";


//axios.defaults.headers.common['Authorization'] = `Bearer ${}`;

function DeleteArea() {
    const [deleteType, setCurrentType] = React.useState( "Member");
    const [currentDB, setCurrentDB] = React.useState("CoastalAdminTest");
    const [validationError, setValidationError] = React.useState(false);
    const [validationText, setValidationText] = React.useState("");
    const [successAlert, setSuccessAlert] = React.useState(false);
    const [loading, setLoading] = React.useState(false);
    const [firstID, setFirstID] = React.useState( "");
    const [secondID, setSecondID] = React.useState( "");
    const [adminPW, setAdminPW] = React.useState( "");
    const [noSecondID, disableSecondID] = React.useState(false);

    const onDBChange = React.useCallback((e: any, newDB: any) => setCurrentDB(newDB.id), []);

    const onDeleteChange = React.useCallback((e: any, newType: any) => {
        setCurrentType(newType)
        if (newType === "Member" || newType === "Division") {
            disableSecondID(false);
        }
        else {
            disableSecondID(true);
            setSecondID("");
        }
    }, []);

    const onFirstIDChange = React.useCallback((e: any) => setFirstID((prev: any) => (e.target.value)), []);

    const onSecondIDChange = React.useCallback((e: any) => setSecondID((prev: any) => (e.target.value)), []);

    const onAdminPWChange = React.useCallback((e: any) => setAdminPW((prev: any) => (e.target.value)), []);

    const handleValidationClose = () => {
        setValidationError(false);
    }

    useEffect(() => {
        // This code will run after 'value' has been updated
        if(!(secondID.charAt(0) === '/') && secondID.length > 0){
            setSecondID("/" + secondID);
        }
    }, [secondID]);

    let token = localStorage.getItem('jwt');
    //console.log('jwt', token);

    const deleteRecord = async () => {
        refreshToken();
        const response =
            await axios
                .delete(
                    localStorage.getItem('baseURL') + deleteType.toLowerCase() + `/delete/` + adminPW + '/' + currentDB + '/' + firstID + secondID,
                    {headers: {'Authorization': `Bearer ${token}`}}
                ).then(() => {
                    setLoading(false);
                    setSuccessAlert(true);
                    setFirstID("");
                    setSecondID("");
                }).catch((error) => {
                    setLoading(false);
                    setValidationText(error.response.request.responseText);
                    setValidationError(true);
                    setFirstID("");
                    setSecondID("");
                });
    }

    const validateDelete = () => {
        setLoading(true);
        if(!(firstID.length > 0)){
            setLoading(false);
            setValidationText("First ID is required");
            setValidationError(true);
        }
        else if(!(adminPW.length > 0)){
            setLoading(false);
            setValidationText("Admin Password is required");
            setValidationError(true);
        }
        else if(!noSecondID && !(secondID.length > 0)){
            setLoading(false);
            setValidationText("Second ID is required for members and divisions");
            setValidationError(true);
        }
        else if(deleteType === "Member" && secondID === "01"){
            setLoading(false);
            setValidationText("Use Subscriber Delete to Delete Subscribers");
            setValidationError(true);
        }
        else {
            deleteRecord();
        }
    }

    return (
        <div className="deletePageWrap">
            <div className="deleteReportCard">
                <span className="typeLabel">
                    Delete Type:
                </span>
                <div className="selectArea">
                    <Autocomplete
                        className="typeSelect"
                        size={"small"}
                        disablePortal
                        disableClearable
                        options={GlobalConstants.DeleteAreas}
                        value={GlobalConstants.DeleteAreas.find(option => option === deleteType) || null}
                        defaultValue={GlobalConstants.DeleteAreas[0]}
                        renderInput={(params) => <TextField {...params}  />}
                        onChange={onDeleteChange}
                    />
                </div>
                <div className="deleteLabelWrap">
                    <span className="deleteLeftLabels">
                            First ID
                        </span>
                    {/*<span style={{display: "inline-block", width: "20%"}}></span>*/}
                    <span className="deleteLabels">
                            Second ID
                        </span>
                    {/*<span style={{display: "inline-block", width: "27%"}}></span>*/}
                    <span className="deleteRightLabels">
                            Admin Password
                        </span>
                </div>
                <div className="deleteInputWrapper">
                    {/*<span style={{display: "inline-block", width: "25%"}}></span>*/}
                    <TextField name="firstID" variant="outlined" className="deleteInput" size="small" type="text"
                               value={firstID} onChange={onFirstIDChange}/>
                    {/*<span style={{display: "inline-block", width: "23%"}}></span>*/}
                    <TextField name="description" variant="outlined" className="deleteInput" size="small"
                               value={secondID} onChange={onSecondIDChange} disabled={noSecondID}/>
                    {/*<span style={{display: "inline-block", width: "20%"}}></span>*/}
                    <TextField name="plan_Type" variant="outlined" className="deleteInput" size="small"
                               value={adminPW} onChange={onAdminPWChange}/>
                    {/*<span style={{display: "inline-block", width: "25%"}}></span>*/}
                </div>
                <div className="deleteButtonWrapper">
                    <Stack direction="row">
                        {/*<Button variant="contained" onClick={getUsers}>Get Users</Button>*/}
                        <LoadingButton className="deleteButtonz" variant="contained" onClick={validateDelete} loading={loading}
                                       loadingPosition="start"
                                       startIcon={<DeleteForeverIcon/>}>Delete</LoadingButton>
                    </Stack>
                </div>
                <Dialog
                    open={validationError}
                    onClose={handleValidationClose}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description">
                    <DialogTitle id="alert-dialog-title">
                        {"Validation Error"}
                    </DialogTitle>
                    <DialogContent>
                        <DialogContentText id="alert-dialog-description">
                            {validationText}
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={handleValidationClose}>OK</Button>
                    </DialogActions>
                </Dialog>
                {successAlert ?
                    <Alert className="deleteAlertStyles" severity='success' onClose={() => setSuccessAlert(false)}
                           variant="filled">
                        <AlertTitle>Success!</AlertTitle>
                        Delete Successful!
                    </Alert> : <></>}
            </div>
            <Stack direction="row" className="deleteButtonBar">
                <Autocomplete
                    className="deleteDbContractSelect"
                    size={"small"}
                    disablePortal
                    disableClearable
                    options={GlobalConstants.VBA_DB}
                    value={GlobalConstants.VBA_DB.find(option => option.id === currentDB) || null}
                    sx={{width: 150}}
                    defaultValue={GlobalConstants.VBA_DB[0]}
                    renderInput={(params) => <TextField {...params}  />}
                    onChange={onDBChange}
                />
            </Stack>
            <Backdrop
                sx={{color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1}}
                open={loading}
            >
                <CircularProgress color="inherit"/>
            </Backdrop>
        </div>
    )
}

export default React.memo(DeleteArea);